import mapboxgl, {
  CircleLayout,
  CirclePaint,
  FillLayout,
  FillPaint,
  LineLayout,
  LinePaint,
  SymbolLayout,
  SymbolPaint
} from 'mapbox-gl'
const isSmall = window.innerWidth < 340
const isMobile = window.innerWidth < 711
const isLarge = window.innerWidth > 1750
export const circleFill: CirclePaint['circle-color'] = [
  'step', // arg 1
  ['get', 'n_firmen'], // arg 2
  '#BA7FB7',
  2,
  '#A757A3',
  4,
  '#7A3F77',
  8,
  '#202346'
]
const circleSizes: CirclePaint['circle-radius'] = [
  'interpolate',
  ['linear'],
  ['zoom'],
  7,
  2,
  14,
  4
]

export const viewSwitzerland = {
  center: [8.226667, 46.801111],
  zoom: isSmall ? 4 : isMobile ? 5.8 : isLarge ? 7.8 : 7.2
}

const circleSizesMobile: CirclePaint['circle-radius'] = [
  'interpolate',
  ['linear'],
  ['zoom'],
  7,
  1,
  14,
  3
]
export const cirlceOpacity: CirclePaint['circle-opacity'] = [
  'interpolate',
  ['linear'],
  ['zoom'],
  7,
  1,
  14,
  1
]
export const cirlceOpacityMobile: CirclePaint['circle-opacity'] = [
  'interpolate',
  ['linear'],
  ['zoom'],
  7,
  0.5,
  14,
  1
]
export const spotLayerStyle: {
  paint: CirclePaint
  layout: CircleLayout
} = {
  paint: {
    'circle-color': '#D3343F',
    'circle-radius': isMobile ? circleSizesMobile : circleSizes,
    'circle-opacity': isMobile ? cirlceOpacityMobile : cirlceOpacity
  },
  layout: { visibility: 'visible' }
}
export const industryLayerStyle: {
  paint: CirclePaint
  layout: CircleLayout
} = {
  paint: {
    'circle-color': '#D3343F',
    'circle-radius': isMobile ? circleSizesMobile : circleSizes,
    'circle-opacity': isMobile ? cirlceOpacityMobile : cirlceOpacity
  },
  layout: { visibility: 'none' }
}
export const circleLayerStyle: { layout: CircleLayout; paint: CirclePaint } = {
  paint: {
    'circle-opacity': ['interpolate', ['linear'], ['zoom'], 7, 1, 12, 1],
    'circle-color': 'rgba(0,0,0,0)',
    'circle-radius': ['interpolate', ['linear'], ['zoom'], 7, 1, 14, 50],
    'circle-stroke-width': 3,
    'circle-stroke-color': '#D3343F'
  },
  layout: {}
}
export const symbolAbnnotationStyle: {
  layout: SymbolLayout
  paint: SymbolPaint
} = {
  layout: {
    'text-field': '',
    'text-variable-anchor': ['top', 'bottom', 'left', 'right'],
    'icon-text-fit-padding': [2, 8, 4, 8],
    'icon-image': 'markerarrow',
    'icon-size': 0.3,
    'text-radial-offset': 0,
    'text-justify': 'auto',
    'icon-offset': [0, -94]
  },
  paint: {
    'text-color': '#fff'
  }
}
export const symbolLayerStyle: { layout: SymbolLayout; paint: SymbolPaint } = {
  layout: {
    'text-field': ['get', 'label'],
    'text-variable-anchor': ['top', 'bottom', 'left', 'right'],
    'icon-text-fit': 'both',
    'icon-text-fit-padding': [2, 8, 4, 8],
    'icon-image': 'textbg',
    'text-radial-offset': 0,
    'text-justify': 'auto',
    'text-font': ['Source Sans Pro Regular', 'Arial Unicode MS Regular'],
    'text-offset': [10, 10]
  },
  paint: {
    'text-color': '#fff'
  }
}
export const cityLabelsStyle: { layout: SymbolLayout; paint: SymbolPaint } = {
  layout: {
    'text-field': ['get', 'label'],
    'text-anchor': 'left',
    'text-radial-offset': 0,
    'text-justify': 'auto',
    'text-offset': [0, 0],

    'text-size': [
      'interpolate',
      ['linear'],
      ['zoom'],
      7,
      0,
      12,
      isMobile ? 20 : 30
    ],
    'text-font': ['Source Sans Pro Regular', 'Arial Unicode MS Regular'],
    'icon-text-fit': 'both',
    'icon-text-fit-padding': [2, 8, 4, 8],
    'icon-image': 'textbg_main',
    visibility: 'none'
  },
  paint: {
    'text-color': '#fff'
  }
}
export const lineLayerStyle: { layout: LineLayout; paint: LinePaint } = {
  paint: {
    'line-width': 10,
    'line-opacity': 1,
    'line-color': '#FFE462'
  },
  layout: {
    'line-cap': 'round'
  }
}
export const shapeLayerStyle: { layout: FillLayout; paint: FillPaint } = {
  paint: { 'fill-color': '#D3343F', 'fill-opacity': 1 },
  layout: {}
}
export function setLayerSource(
  map: mapboxgl.Map,
  layerId: string,
  source: string,
  sourceLayer?: string
) {
  const oldLayers = map.getStyle().layers
  if (!oldLayers) return
  const layerIndex = oldLayers.findIndex(l => l.id === layerId)
  const layerDef = oldLayers[layerIndex]
  const before = oldLayers[layerIndex + 1] && oldLayers[layerIndex + 1].id
  layerDef.source = source
  if (sourceLayer) {
    layerDef['source-layer'] = sourceLayer
  }
  map.removeLayer(layerId)
  map.addLayer(layerDef, before)
}

export const toggleVisibility = (
  map: mapboxgl.Map,
  layerid: string,
  visible: boolean
) => {
  map.setLayoutProperty(layerid, 'visibility', visible ? 'visible' : 'none')
}

export const spotsBlue = {
  id: 'spots',
  prop: 'circle-color',
  value: '#202346'
}
export const spotsRed = {
  id: 'spots',
  prop: 'circle-color',
  value: '#D3343F'
}

export const spotsFullOpacity = {
  id: 'spots',
  prop: 'circle-opacity',
  value: 1
}
export const spotsLowOpacity = {
  id: 'spots',
  prop: 'circle-opacity',
  value: 0.2
}
